import React, { useEffect, useRef } from 'react';
import '../css/WaveSeparator.css'; 

const WaveSeparator = () => {
  const canvasRef = useRef(null);

  useEffect(() => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext('2d');
    const width = (canvas.width = window.innerWidth);
    const height = (canvas.height = 150); 


    const drawWave = (amplitude, frequency, phase, color, blurAmount) => {
      ctx.save();
      ctx.beginPath();
      ctx.moveTo(0, height / 2);

      for (let x = 0; x <= width; x++) {
        const y = height / 2 + amplitude * Math.sin((x / width) * frequency * Math.PI * 2 + phase);
        ctx.lineTo(x, y);
      }

      ctx.strokeStyle = color;
      ctx.lineWidth = 2;
      ctx.shadowBlur = blurAmount;
      ctx.shadowColor = color;
      ctx.stroke();
      ctx.restore();
    };

    const clearCanvas = () => {
      ctx.clearRect(0, 0, width, height);
      ctx.fillStyle = '#090808'; 
      ctx.fillRect(0, 0, width, height);
    };

    const renderWaves = () => {
      clearCanvas();
      drawWave(67, 1, 0, 'rgba(255, 255, 255, 0.4)', 28);
      drawWave(52, 1.5, Math.PI, 'rgba(220, 220, 220, 0.2)', 8);
      drawWave(35, 1.2, Math.PI / 2, 'rgba(180, 180, 180, 0.2)', 6);
      drawWave(28, 1.8, Math.PI / 4, 'rgba(150, 150, 150, 0.3)', 17);
      drawWave(17, 2, Math.PI / 1.5, 'rgba(120, 120, 120, 0.2)', 3);
      drawWave(8, 2.5, Math.PI / 3, 'rgba(90, 90, 90, 0.6)', 7);
    };

    renderWaves();

    window.addEventListener('resize', () => {
      canvas.width = window.innerWidth;
      canvas.height = 150;
      renderWaves();
    });

    return () => {
      window.removeEventListener('resize', () => {});
    };
  }, []);

  return (
    <div className="wave-separator">
      <canvas ref={canvasRef} style={{ display: 'block', width: '100%', height: '150px' }} />
    </div>
  );
};

export default WaveSeparator;
